module.exports = __webpack_public_path__ + "static/img/850f904f19f20f25502e5bb9850002c.4912081f.png";